import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Proxima Nova, sans-serif",
  },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: "0px",
          fontFamily: "Proxima Nova, sans-serif",
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #1b2838",
          },
        },
      },
    },
  },
});

export default theme;
